module.exports = __webpack_public_path__ + "static/134118515-00d8e4cdb07cdc2b462fe6dd87584818.jpg";